const translations = {
  "en": {
    "Unlock Remaining Portfolios": "Unlock Remaining Portfolios"
  },
  "zh-tw": {
    "Unlock Remaining Portfolios": "解鎖更多投資組合"
  }
};

export default translations;
